export function checkApiDataResult(data)
{
    if( !data )
    {
        return true;
    }
    
    if( !data.data.result || data.data.result.length < 1 )
    {
        return true;
    }

    return false;
}

export function checkApiDataMetrics(data)
{
    if( !data )
    {
        return true;
    }
        
    if( !data.metrics )
    {
        return true;
    }
    
    return false;
}

export function getStartEndStep(isCalendar)
{
    let term = sessionStorage.getItem('term');

    if(!term)
    {
        term = '1';
    }

    let startTime = document.getElementById('startTime');
    let endTime = document.getElementById('endTime');

    let start;
    let end;
    let step;

    if(isCalendar)
    {
        start = Date.parse(startTime.value) / 1000;
        end = Date.parse(endTime.value) / 1000;
        step = Math.floor((end - start) / 900);
    }
    else
    {
        end = Math.floor(new Date().getTime() / 1000);
        start = end - (Number(term) * 60);
        step = calcStep(term);
    }

    return {start: start, end: end, step: step};
}

export function calcStep(term) {
    let result = 1;
  
    switch (term) {
        case "1":
            result = 1;
            break;
        case "5":
            result = 1;
            break;
        case "15":
            result = 5;
            break;
        case "30":
            result = 5;
            break;
        case "60":
            result = 5;
            break;
        case "180":
            result = 12;
            break;
        case "360":
            result = 24;
            break;
        case "720":
            result = 48;
            break;
        case "1440":
            result = 96;
            break;
        default:
            result = 1;
            break;
    }
    return result;
}

export function isEmptyObj(param) {
    return Object.keys(param).length === 0;
}

const SUBFRAME_COLORS = ['#4481eb', '#0ba360', '#c471f5', '#d86195'];
const PLP_COLORS = [
    '#3dd5f3',
    '#6ea8fe',
    '#a98eda',
    '#e685b5',
    '#20c997',
    '#0aa2c0',
    '#a370f7',
    '#f0903a',
    '#3dd5f3',
    '#6ea8fe',
    '#a98eda',
    '#e685b5',
    '#20c997',
    '#0aa2c0',
    '#a370f7',
    '#f0903a'
];

export function makePieChartData( subframeInfoResult, plpInfoResult, plpBytesResult)
{
    //순서가 다르게 들어올때가 있어서 정렬
    function sortByField(arr, type) {
        return arr.sort((a, b) => parseFloat(a.metric[type]) - parseFloat(b.metric[type]));
    }
    
    subframeInfoResult = sortByField(subframeInfoResult, 'subframe');
    plpInfoResult = sortByField(plpInfoResult, 'plp');
    plpBytesResult = sortByField(plpBytesResult, 'plp');

    //subframe 별로 plp info 배열 정렬
    let plpInfo = [];
    subframeInfoResult.forEach(function(item)
    {
        let result = plpInfoResult.filter(x => {
            return x.metric.subframe === item.metric.subframe;
        });

        plpInfo.push(result);
    });

    //subframe size
    let subframeSize = [];
    plpInfo.forEach(function(item, i)
    {
        let plpSum = 0;
        plpSum += Number(subframeInfoResult[i].metric.remain_usage);
        item.forEach(function(x)
        {
            plpSum += Number(x.metric.usage);
        });

        let data = {
            "id": subframeInfoResult[i].metric.subframe,
            "usage": plpSum,
        };
        subframeSize.push(data);
    });

    //plp usage data
    let plpSize = [];
    plpInfo.forEach(function(item, i)
    {
        item.forEach(function(x)
        {
            let data = {
                "id": x.metric.plp,
                "usage": Number(x.metric.usage),
                "availableBitrate": Number(x.metric.available_bitrate)
            };

            let nullData = {
                "id": "null",
                "usage": 0,
                "availableBitrate": 0
            };

            plpSize.push(data);
            plpSize.push(nullData);
        });

        let remainUsage = Number(subframeInfoResult[i].metric.remain_usage);
        if(remainUsage !== 0)
        {
            plpSize.pop(); // 마지막 nullData를 지워주고, 아래의 remainData를 넣어주어야함.

            let remainData = {
                "id": "null",
                "usage": remainUsage,
                "availableBitrate": 0
            };

            plpSize.push(remainData);
        }
    });

    //subframe chart Object
    let subframeChartData = [];
    subframeSize.forEach(function(item, i)
    {
        let subframeData = {
            name: `Subframe${item.id}`,
            y: item.usage,
            color: `${SUBFRAME_COLORS[i]}`
        };

        subframeChartData.push(subframeData);
    });

    //plp usage chart Object
    let plpChartData = [];
    plpSize.forEach(function(item)
    {
        let plpData = {
            name: item.id !== 'null' ? `PLP${item.id}` : '',
            y: item.usage,
            color: item.id !== 'null' ? `${PLP_COLORS[Number(item.id)]}` : '#353535'
        };

        plpChartData.push(plpData);
    });

    //plp percent chart Object
    let plpPerChartData = [];
    plpSize.forEach(function(item)
    {
        let plpPer = plpBytesResult.find(x => { return x.metric.plp === item.id; });

        if( plpPer )
        {
            //plp 사용량
            let plpUsage = item.usage;
            //100이 넘을경우 100으로
            let plpPercent = Math.min((Number(plpPer.values[plpPer.values.length - 1][1]) * 8 / item.availableBitrate) * 100, 100);
            let per = 0;
            if(plpPercent > 100)
            {
                per = plpUsage;
            }
            else
            {
                per = plpUsage * plpPercent / 100;
            }

            //plp에서 사용량 나머지
            let emptyPer = item.usage - per;
            if(emptyPer < 0)
            {
                emptyPer = 0;   
            }

            let perObj = {
                name: `${plpPercent.toFixed(2)}%`,
                y: per,
                color: `${PLP_COLORS[Number(item.id)]}`,
            };

            let emptyPerObj = {
                name: "",
                y: emptyPer,
                color: '#484848'
            };

            plpPerChartData.push(perObj);
            plpPerChartData.push(emptyPerObj);
        }
        else
        {
            let plpNull = item.usage;

            let plpNullObj = {
                name: "",
                y: plpNull,
                color: '#353535'
            };

            plpPerChartData.push(plpNullObj);
        }
    });

    return {
        subframeChartData : subframeChartData,
        plpChartData : plpChartData,
        plpPerChartData : plpPerChartData
    }
}

export function makeResultData(start, end, step, result )
{
    let mergeData = [];
    let checkData = [];

    for(let value of result)
    {
        let addData = Number(value[1]);
        let timeLabel = value[0];

        for(let idx = start + step; idx < timeLabel; idx += step )
        {
            checkData.push([idx, null]);
        }

        start = timeLabel;
        checkData.push([timeLabel, addData]);
    }

    while((end - start) >= step )
    {
        checkData.push([start + step, null]);
        start += step;
    }
    
    return mergeData.concat(checkData);
}

export function makeChartData(data, plp=null)
{
    let dataArray = [];

    for (let i = 0; i < data.length ; i++)
    {
        let addData;

        if( data[i][1] == null )
        {
            addData = null;
        }
        else
        {
            if ( !plp )
            {
                addData = Number(data[i][1]);
            }
            else
            {
                addData = Number(data[i][1]) * 8 / 1000000;
            }
        }

        let timeLabel = data[i][0] * 1000;

        dataArray.push([timeLabel, addData]);
    }

    return dataArray;
}

export function updateChartData(chart, data, lastTime, plp=null)
{
    for (let i = 0; i < data.length; i++)
    {
        if (data[i][0] > lastTime)
        {
            let addData;

            if( data[i][1] == null )
            {
                addData = null;
            }
            else
            {
                if ( !plp )
                {
                    addData = Number(data[i][1]);
                }
                else
                {
                    addData = Number(data[i][1]) * 8 / 1000000;
                }
            }

            let timeLabel = data[i][0] * 1000;

            chart.series[0].addPoint([timeLabel, addData], true, true);
        }
    }
}

export function valuesTimeDisp(resValues, tag)
{
    let firstTime = resValues[0][0];
    let lastTime = resValues[resValues.length - 1][0];

    let firstTimeLabel = new Date(firstTime*1000).toTimeString().split(" ")[0];
    let lastTimeLabel = new Date(lastTime*1000).toTimeString().split(" ")[0];
    
    let mainVal = Number(resValues[resValues.length - 1][1]);

    let maxVal = getMaxValue(resValues);
    let minVal = getMinValue(resValues);

    let mainValue = tag === 'rfFer'? Math.round(mainVal) : mainVal.toFixed(2);
    let maxValue = tag === 'rfFer'? Math.round(maxVal) : maxVal.toFixed(2);
    let minValue = tag === 'rfFer'? Math.round(minVal) : minVal.toFixed(2);

    if(tag === 'fecOverhead' || tag === 'mwBandwidth')
    {
        progressBarChart(mainValue, maxValue, minValue, tag);
    }

    return {
        firstTimeLabel: firstTimeLabel,
        lastTimeLabel: lastTimeLabel,
        mainValue: mainValue,
        maxValue: maxValue,
        minValue: minValue
    }
}

function progressBarChart(value, maxValue, minValue, tag)
{
    if(minValue < 5)
    {
        let target = document.querySelector(`.${tag}  .limit-text.min`);
        target.style.marginLeft = "-14px";
    }

    if(maxValue > 95)
    {
        let target = document.querySelector(`.${tag} .limit-text.max`);
        target.style.marginLeft = "-14px";
    }

    document.querySelector(`.${tag} .limit-value`).textContent = `${value}%`;

    let perText = document.querySelector(`.${tag} .limit-value`);
    perText.style.left = `${value}%`;
    perText.classList.add('animateLeft');
    setTimeout(()=> perText.classList.remove("animateLeft"), 500);

    let minMark = document.querySelector(`.${tag} .limit-bar.min`);
    minMark.style.left = `${minValue}%`;
    minMark.classList.add('animateLeft');
    setTimeout(()=> minMark.classList.remove("animateLeft"), 500);

    let min = document.querySelector(`.${tag} .min`);
    min.style.left = `${minValue}%`;
    min.classList.add('animateLeft');
    setTimeout(()=> min.classList.remove("animateLeft"), 500);

    let maxMark = document.querySelector(`.${tag} .limit-bar.max`);
    maxMark.style.left = `${maxValue}%`;
    maxMark.classList.add('animateLeft');
    setTimeout(()=> maxMark.classList.remove("animateLeft"), 500);

    let max = document.querySelector(`.${tag} .max`);
    max.style.left = `${maxValue}%`;
    max.classList.add('animateLeft');
    setTimeout(()=> max.classList.remove("animateLeft"), 500);

    let mainBar = document.querySelector(`.${tag} .main-bar`);
    mainBar.style.width = `${value}%`;
    mainBar.classList.add('animateWidth');
    setTimeout(()=> mainBar.classList.remove("animateWidth"), 500);
}

function getMaxValue(data)
{
    let maxValue = data[0][1];
    for (let i = 0; i < data.length; i++)
    {
        if( maxValue == null )
        {
            maxValue = data[i][1];
        }

        if (maxValue < data[i][1] && data[i][1])
        {
            maxValue = data[i][1];
        }
    }

    return maxValue;
}

export function getMinValue(data)
{
    let minValue = data[0][1];
    for (let i = 0; i < data.length; i++)
    {
        if( minValue == null )
        {
            minValue = data[i][1];
        }

        if (minValue > data[i][1] && data[i][1] != null)
        {
            minValue = data[i][1];
        }
    }

    return minValue;
}

export function ChartTime({firstTime, lastTime})
{
    return (
        <div className="d-flex justify-content-between mb-2">
            <div className="chart-time-label">{firstTime}</div>
            <div className="chart-time-label">{lastTime}</div>
        </div>
    )
}

export function DisplayMaxMinValue ({label = null, term, max, min, unit})
{
    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="label sm">Max in {term}{label}</div>
                <div className="value-label sm">{max}{unit}</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="label sm min">Min in {term}{label}</div>
                <div className="value-label sm">{min}{unit}</div>
            </div>
        </>
    )
}

export const timeTextChange = (term, isCalendar) =>
{
    let timeText = "";
    if(isCalendar)
    {
        if (Number(term) === 1)
        {
            timeText = "60 sec";
        }
        else if (Number(term) <= 60)
        {
            timeText = `${term} min`;
        }
        else
        {
            let hours   = Math.floor(Number(term) / 60);
            let minutes = Number(term) % 60;
            
            if(minutes === 0)
            {
                if(hours === 1)
                {
                    timeText = `${hours} hour`;
                }
                else
                {
                    timeText = `${hours} hours`;
                }
            }
            else
            {
                timeText = `${hours}h ${minutes}min`;
            }
        }
    }
    else
    {
        if (term === "1") timeText = "60 sec";
        else if (term === "5") timeText = "5 min";
        else if (term === "15") timeText = "15 min";
        else if (term === "30") timeText = "30 min";
        else if (term === "60") timeText = "60 min";
        else if (term === "180") timeText = "3 hours";
        else if (term === "360") timeText = "6 hours";
        else if (term === "720") timeText = "12 hours";
        else if (term === "1440") timeText = "24 hours";
    }

    return timeText;
}

// export function getLimitValue(metricName, tag)
// {
//     let limitArr = monDataArr.alertRules.find(x => { return x.metric === metricName; });
//     let limitValue;

//     let sectionTag = document.querySelector(`#${tag}`);
//     let alertBellTag = document.querySelector(`#${tag} .alertBell`);
    
//     if (!monStatusVar.calrendar)
//     {
//         if (limitArr == undefined || limitArr.enabled == false)
//         {
//             limitValue = null;
//             if ( tag )
//             {
//                 if( alertBellTag )
//                 {
//                     alertBellTag.remove();
//                 }
//             }
//         }
//         else
//         {
//             limitValue = limitArr.limit;
            
//             if ( tag )
//             {
//                 if (!document.querySelector(`#${tag} .alertBell`))
//                 {
//                     let div = document.createElement('div');
//                     let i = document.createElement('i');

//                     div.className = 'alertBell';
//                     i.className = 'bi bi-bell';

//                     div.append(i);
//                     sectionTag.prepend(div);
//                 }
//             }
//         }
//     }
//     else
//     {
//         limitValue = null;
//         if(alertBellTag)
//         {
//             alertBellTag.remove();
//         }
//     }
//     return limitValue;
// }

export function makeStlChartData(stlValues, fecValues)
{
    let stlDataArr = [];
    let fecDataArr = [];

    for (let i = 0; i < stlValues.length ; i++)
    {
        let stlMb;
        let fecMb;

        if( stlValues[i][1] == null )
        {
            stlMb = null;
            fecMb = null;
        }
        else
        {
            stlMb = parseFloat(( Number(stlValues[i][1]) * 8 / 1000000 ).toFixed(2));
            fecMb = parseFloat(( ( Number(stlValues[i][1]) * 8 + Number(fecValues[i][1]) * 8 ) / 1000000).toFixed(2));
        }
        
        let timeLabel = stlValues[i][0] * 1000;

        stlDataArr.push([timeLabel, stlMb]);
        fecDataArr.push([timeLabel, fecMb]);
    }

    return {
        stlDataArr : stlDataArr,
        fecDataArr : fecDataArr
    };
}

export function updateStlChartData(chart, stlValues, fecValues, lastTime)
{
    for (let i = 0; i < stlValues.length; i++)
    {
        if (stlValues[i][0] > lastTime)
        {
            let stlMb;
            let fecMb;

            if( stlValues[i][1] == null )
            {
                stlMb = null;
                fecMb = null;
            }
            else
            {
                stlMb = parseFloat(( Number(stlValues[i][1]) * 8 / 1000000 ).toFixed(2));
                fecMb = parseFloat(( ( Number(stlValues[i][1]) * 8 + Number(fecValues[i][1]) * 8 ) / 1000000).toFixed(2));
            }

            let timeLabel = stlValues[i][0] * 1000;

            chart.series[0].addPoint([timeLabel, fecMb], true, true);
            chart.series[1].addPoint([timeLabel, stlMb], true, true);
        }
    }
}

export function makeStlBitrateChartData(stlValues, fecValues)
{
    let stlDataArr = [];
    let fecDataArr = [];

    for (let i = 0; i < stlValues.length ; i++)
    {
        let stlMb;
        let fecMb;

        if( stlValues[i][1] == null )
        {
            stlMb = null;
            fecMb = null;
        }
        else
        {
            stlMb = parseFloat(( Number(stlValues[i][1]) / 1000000 ).toFixed(2));
            fecMb = parseFloat(( ( Number(stlValues[i][1]) + Number(fecValues[i][1]) ) / 1000000).toFixed(2));
        }
        
        let timeLabel = stlValues[i][0] * 1000;

        stlDataArr.push([timeLabel, stlMb]);
        fecDataArr.push([timeLabel, fecMb]);
    }

    return {
        stlDataArr : stlDataArr,
        fecDataArr : fecDataArr
    };
}

export function updateStlBitrateChartData(chart, stlValues, fecValues, lastTime)
{
    for (let i = 0; i < stlValues.length; i++)
    {
        if (stlValues[i][0] > lastTime)
        {
            let stlMb;
            let fecMb;

            if( stlValues[i][1] == null )
            {
                stlMb = null;
                fecMb = null;
            }
            else
            {
                stlMb = parseFloat(( Number(stlValues[i][1]) / 1000000 ).toFixed(2));
                fecMb = parseFloat(( ( Number(stlValues[i][1]) + Number(fecValues[i][1]) ) / 1000000).toFixed(2));
            }

            let timeLabel = stlValues[i][0] * 1000;

            chart.series[0].addPoint([timeLabel, fecMb], true, true);
            chart.series[1].addPoint([timeLabel, stlMb], true, true);
        }
    }
}

export function stlValuesTimeDisp(stlValues, fecValues)
{
    let firstTime = stlValues[0][0];
    let lastTime = stlValues[stlValues.length - 1][0];

    let firstTimeLabel = new Date(firstTime*1000).toTimeString().split(" ")[0];
    let lastTimeLabel = new Date(lastTime*1000).toTimeString().split(" ")[0];

    let stlLatestData = (stlValues[stlValues.length - 1][1]);
    let fecLatestData = (fecValues[fecValues.length - 1][1]);

    let stlMb = (stlLatestData * 8 / 1000000).toFixed(2);
    let fecMb = ((stlLatestData * 8 + fecLatestData * 8) / 1000000).toFixed(2);

    let maxVal = getMaxValue(stlValues);
    let minVal = getMinValue(stlValues);

    let maxValue = ((maxVal * 8) / 1000000).toFixed(2);
    let minValue = ((minVal * 8) / 1000000).toFixed(2);

    return {
        firstTimeLabel: firstTimeLabel,
        lastTimeLabel: lastTimeLabel,
        stlMb: stlMb,
        fecMb: fecMb,
        maxValue: maxValue,
        minValue: minValue
    }
}

export function stlBitrateValuesTimeDisp(stlValues, fecValues)
{
    let firstTime = stlValues[0][0];
    let lastTime = stlValues[stlValues.length - 1][0];

    let firstTimeLabel = new Date(firstTime*1000).toTimeString().split(" ")[0];
    let lastTimeLabel = new Date(lastTime*1000).toTimeString().split(" ")[0];

    let stlLatestData = (stlValues[stlValues.length - 1][1]);
    let fecLatestData = (fecValues[fecValues.length - 1][1]);

    let stlMb = (stlLatestData / 1000000).toFixed(2);
    let fecMb = ((stlLatestData + fecLatestData) / 1000000).toFixed(2);

    let maxVal = getMaxValue(stlValues);
    let minVal = getMinValue(stlValues);

    let maxValue = (maxVal / 1000000).toFixed(2);
    let minValue = (minVal / 1000000).toFixed(2);

    return {
        firstTimeLabel: firstTimeLabel,
        lastTimeLabel: lastTimeLabel,
        stlMb: stlMb,
        fecMb: fecMb,
        maxValue: maxValue,
        minValue: minValue
    }
}

export function makeBitrateSumData(data, subData)
{
    let dataArray = [];

    for(let i = 0; i < subData.length; i++)
    {
        let dataTemp = [];
        let time;
        let value = 0;
        for(let j = 0; j < data.length; j++)
        {
            time = data[j].values[i][0];
            value += Number(data[j].values[i][1]);
        }
        dataTemp.push(time);
        dataTemp.push(String(Math.ceil(value)));

        dataArray.push(dataTemp);
    }

    return dataArray;
}

export function makeMsystemChartData(data, dataType)
{
    let dataArray = [];

    for (let i = 0; i < data.length ; i++)
    {
        let addData;

        if( data[i][1] == null )
        {
            addData = null;
        }
        else
        {
            if ( dataType === 'bitrate' )
            {
                addData = data[i][1] * 8;
            }
            else
            {
                addData = Number(data[i][1]);
            }
        }

        let timeLabel = data[i][0] * 1000;
            
        dataArray.push([timeLabel, addData]);
    }

    return dataArray;
}

export function updateMsystemChartData(chart, data, lastTime, seriesNo, dataType)
{
    let preTimeStamp = 0;

    for (let i = 0; i < data.length; i++)
    {
        if (data[i][0] > lastTime)
        {
            if( preTimeStamp === data[i][0] )
            {
                return;
            }

            let addData;

            if( data[i][1] === null )
            {
                addData = null;
            }
            else
            {
                if(dataType === 'bitrate')
                {
                    addData = data[i][1] * 8;
                }
                else
                {
                    addData = Number(data[i][1]);
                }
            }

            let timeLabel = data[i][0] * 1000;

            chart.series[seriesNo].addPoint([timeLabel, addData], true, true);
        }

        preTimeStamp = data[i][0];
    }
}

export function updateMuxOutputChartData(chart, serviceData, llsData, lastTime)
{
    for (let i = 0; i < llsData.length; i++)
    {
        if (llsData[i][0] > lastTime)
        {
            let llsMb;
            let serviceMb;

            if( llsData[i][1] == null )
            {
                llsMb = null;
            }
            else
            {
                llsMb = llsData[i][1] * 8;
            }

            if( serviceData[i][1] == null )
            {
                serviceMb = null;
            }
            else
            {
                serviceMb = serviceData[i][1] * 8;
            }

            let timeLabel = llsData[i][0] * 1000;

            chart.series[0].addPoint([timeLabel, llsMb], true, true);
            chart.series[1].addPoint([timeLabel, serviceMb], true, true);
        }
    }
}

export function muxOutputTimeDisp(values1, values2)
{
    let firstTime = values1[0][0];
    let lastTime = values1[values1.length - 1][0];

    let firstTimeLabel = new Date(firstTime*1000).toTimeString().split(" ")[0];
    let lastTimeLabel = new Date(lastTime*1000).toTimeString().split(" ")[0];

    let firstValue = unitBpsConvert(values1[values1.length - 1][1] * 8);
    let secondValue = unitBpsConvert(values2[values2.length - 1][1] * 8);

    let maxVal = getMaxValue(values1);
    let minVal = getMinValue(values1);

    let maxValue = unitBpsConvert(maxVal * 8);
    let minValue = unitBpsConvert(minVal * 8);

    return {
        firstTimeLabel: firstTimeLabel,
        lastTimeLabel: lastTimeLabel,
        service: firstValue,
        lls: secondValue,
        maxValue: maxValue,
        minValue: minValue
    }
}

export function unitBpsConvert(value)
{
    let resultStr;
    if(value >= 1000 && value < 1000000)
    {
        resultStr = `${(value / 1000).toFixed(2)}Kbps`;
    }
    else if(value >= 1000000)
    {
        resultStr = `${(value / 1000000).toFixed(2)}Mbps`;
    }
    else
    {
        resultStr = `${value}bps`;
    }

    return resultStr;
}

export function dateTimeFormat(date)
{
    let temp = new Date(date * 1000).toISOString().split('T');
    let dateTemp = temp[0].split('-');
    let year = dateTemp[0];
    let month = dateTemp[1];
    let day = dateTemp[2];
    let timeTemp = temp[1].split('.');
    let time = timeTemp[0];
    let msec = timeTemp[1].slice(0, -1);

    return {year, month, day, time, msec};
}

export function updateErrorCountChartData(chart, data, lastTime)
{
    let rtpErrorData = 0;

    for (let i = 0; i < data.length; i++)
    {
        if (data[i][0] > lastTime)
        {
            if( data[i][1] == null )
            {
                rtpErrorData = null;
            }
            else
            {
                rtpErrorData = Math.round( Number(data[i][1]) * 100 ) / 100;
            }

            let timeLabel = data[i][0] * 1000;

            chart.series[0].addPoint([timeLabel, rtpErrorData], true, true);
        }
    }
}

export function errorCountDisplay(data)
{
    let firstTime = data[0][0];
    let lastTime = data[data.length - 1][0];

    let firstTimeLabel = new Date(firstTime*1000).toTimeString().split(" ")[0];
    let lastTimeLabel = new Date(lastTime*1000).toTimeString().split(" ")[0];

    let mainValue = Math.round(Number(data[0][1])*100) / 100;

    return {
        firstTimeLabel: firstTimeLabel,
        lastTimeLabel: lastTimeLabel,
        mainValue: mainValue,
    }
}

export function chartMaxValue(limitValue, chartData)
{
    let chartMaxVal = null;

    let dataMaxVal = Math.max.apply(Math, chartData.map(function (o) { return o[1]; }));

    if( limitValue )
    {
        if(limitValue > dataMaxVal)
        {
            chartMaxVal = limitValue;
        }
    }
    else if(limitValue === null && dataMaxVal === 0)
    {
        chartMaxVal = 1;
    }

    return chartMaxVal;
}

export function updateLlsChartData(chart, chartData, lastTime)
{
    let addDataSetArr = [[]];
    let preTimeStamp = 0;
    
    for(let [seriesIdx, item] of chartData.entries())
    {
        addDataSetArr[seriesIdx] = [];
        let dataIdx = 0;

        for(let value of item.data)
        {
            if (value[0] > lastTime)
            {
                if( preTimeStamp === value[0] )
                {
                    return;
                }

                let addData;

                if( value[1] == null )
                {
                    addData = null;
                }
                else
                {
                    addData = value[1];
                }

                let timeLabel = value[0];

                addDataSetArr[seriesIdx][dataIdx] = {seriesIdx: seriesIdx, dataIdx: dataIdx, data: [timeLabel, addData]};
                dataIdx++;
            }

            preTimeStamp = value[0];
        }
    }

    for( let roop1 = 0; roop1<addDataSetArr[0].length; roop1++ )
    {
        for( let roop2 = 0; roop2<addDataSetArr.length; roop2++ )
        {
            chart.series[roop2].addPoint(addDataSetArr[roop2][roop1].data, true, true);
        }
    }
}

export function simpleTimeDisp(resValues)
{
    let firstTime = resValues[0][0];
    let lastTime = resValues[resValues.length - 1][0];

    let firstTimeLabel = new Date(firstTime*1000).toTimeString().split(" ")[0];
    let lastTimeLabel = new Date(lastTime*1000).toTimeString().split(" ")[0];

    let mainValue = unitBpsConvert(resValues[resValues.length - 1][1] * 8);
    
    return {
        firstTimeLabel: firstTimeLabel,
        lastTimeLabel: lastTimeLabel,
        mainValue: mainValue,
    }
}

export function updateTsiChartData(chart, chartData, lastTime)
{
    let addDataSetArr = [[]];
    let preTimeStamp = 0;
    
    for(let [seriesIdx, item] of chartData.entries())
    {
        addDataSetArr[seriesIdx] = [];
        let dataIdx = 0;

        for(let value of item.data)
        {
            if (value[0] > lastTime)
            {
                if( preTimeStamp === value[0] )
                {
                    return;
                }

                let addData;

                if( value[1] == null )
                {
                    addData = null;
                }
                else
                {
                    addData = value[1];
                }

                let timeLabel = value[0];
                
                addDataSetArr[seriesIdx][dataIdx] = {seriesIdx: seriesIdx, dataIdx: dataIdx, data: [timeLabel, addData]};
                dataIdx++;
            }
            preTimeStamp = value[0];
        }
    }

    for( let roop1 = 0; roop1<addDataSetArr[0].length; roop1++ )
    {
        for( let roop2 = 0; roop2<addDataSetArr.length; roop2++ )
        {
            chart.series[roop2].addPoint(addDataSetArr[roop2][roop1].data, true, true);
        }
    }
}